import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('modules_token');
    if (!token) { setLoading(false); return; }

    api.get('/modules/auth/me')
      .then(res => setClient(res.data.client))
      .catch(() => localStorage.removeItem('modules_token'))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await api.post('/modules/auth/login', { email, password });
    localStorage.setItem('modules_token', res.data.token);
    setClient(res.data.client);
    return res.data;
  };

  const register = async (data) => {
    const res = await api.post('/modules/auth/register', data);
    localStorage.setItem('modules_token', res.data.token);
    setClient(res.data.client);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('modules_token');
    setClient(null);
  };

  return (
    <AuthContext.Provider value={{ client, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
